import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { getDate, getTime } from "../../../../utilities/date";
import api from "../../../../api/api";
import { AuthReducerProps } from "../../../../store/reducers/authReducer";
import { useSelector } from "react-redux";

import ImgPostNew from "../../../../assets/post_new.gif";
import ImgPost from "../../../../assets/post.gif";

interface ForumPostProps {
    id: string;
    name: string;
    date: number;
}

interface ForumTopicProps {
    author: string;
    created: number;
    id: string;
    slug: string;
    isAnnouncement: boolean;
    isLocked: boolean;
    isNew: boolean;
    isSticky: boolean;
    lastPost: ForumPostProps | null;
    replies: number;
    title: string;
    views: number;
}

interface RecentPostsResponseData {
    forumCategoryId: null;
    recentTopics: ForumTopicProps[];
}

interface Props {
    url: string;
    collapse: () => void;
}

const RecentPosts: React.FC<Props> = ({ url, collapse }) => {
    const [data, setData] = useState<RecentPostsResponseData | null>(null);

    const uid: string | null = useSelector(
        (state: AuthReducerProps) => state.uid,
    );

    /***************************************************
     * Startup
     ***************************************************/
    useEffect(() => {
        setData(null);
        api.get(url)
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                console.log("Failed to load the recent posts");
                console.log("error", error);
                console.log("error.response", error.response);
            });
    }, [url, uid]);

    /***************************************************
     * Event handlers
     ***************************************************/

    /***************************************************
     * Render
     ***************************************************/
    let content = null;

    if (data) {
        content = data.recentTopics.map((forumTopic, index) => {
            let title = forumTopic.title;
            let date = "";
            let author = "";
            let link = "/forum/topic/" + forumTopic.slug;

            if (forumTopic.lastPost) {
                let created: Date = new Date(forumTopic.lastPost.date);
                author = forumTopic.lastPost.name;
                date = getDate(created) + ", " + getTime(created);
            }

            return (
                <div
                    key={index}
                    className="alternate-table-entry flex-column p-2"
                >
                    <Link
                        to={link}
                        className="w-100 d-flex align-items-center sidebar-navigation-list-item-link"
                        onClick={collapse}
                    >
                        <img
                            src={forumTopic.isNew ? ImgPostNew : ImgPost}
                            alt={forumTopic.isNew ? "Unread post" : "Read post"}
                            className="mr-2 img-fluid flex-shrink-0"
                        />
                        <span className="text-overflow font-weight-light-bold">
                            {forumTopic.replies > 0 ? "RE: " : ""}
                            {title}
                        </span>
                    </Link>
                    <div className="w-100 d-flex">
                        <strong className="mr-2">by</strong>
                        <span className="text-overflow">{author}</span>
                    </div>
                    <div className="w-100 d-flex">
                        <strong className="mr-2">on</strong>
                        <span className="text-overflow">{date}</span>
                    </div>
                </div>
            );
        });
    }

    return <React.Fragment>{content}</React.Fragment>;
};

export default RecentPosts;
